import { SalesforceServices as SalesforceLogo } from '@clearkit/icons';

import salesforceTheme from './theme';

export default {
  logo: SalesforceLogo,
  theme: salesforceTheme,
};
